"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLocale = exports.LOCALE = void 0;
const messages_1 = require("./messages");
exports.LOCALE = createLocale();
function createLocale() {
    return {
        FUNCTIONS: (0, messages_1.FUNCTIONS)(),
        MESSAGES: (0, messages_1.MESSAGES)(),
        ALPHABETS: (0, messages_1.ALPHABETS)(),
        NUMBERS: (0, messages_1.NUMBERS)(),
        COMBINERS: {},
        CORRECTIONS: {},
        SUBISO: (0, messages_1.SUBISO)()
    };
}
exports.createLocale = createLocale;
